var path = '/templates/projects.settings/initialization/login_evaluator.html';
var html = "<div id=projectSettingsBase><h1 class=config-title>{{ 'projectsSettings.initialization.loginEvaluator.roguin_hantei' | translate }}</h1><zc-session-sampler project=project title=\"{{ 'projectsSettings.initialization.loginEvaluator.roguin_ritsu' | translate }}\" indicator=login_rate></zc-session-sampler><p class=config-lead>{{ 'projectsSettings.initialization.loginEvaluator.roguinshitakadouka_no_hantei' | translate }}</p><zc-login-evaluator-editor project-id=project.id></zc-login-evaluator-editor></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ../enterprise/src/zenclerk_modules/projects.settings/initialization/login_evaluator.html
// module id = 1545
// module chunks = 0